import { isStandardBackendError } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import {
	useTranslationDefault,
	useTranslationInvestor,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

const FILE_UNREADABLE_ERROR_CODE = 30202;

export const useFileUploadErrorHandler = () => {
	const tInvestor = useTranslationInvestor();
	const tDefault = useTranslationDefault();

	return (error: unknown) => {
		// eslint-disable-next-line no-console
		console.error(error);

		if (isStandardBackendError(error) && error.error?.code === FILE_UNREADABLE_ERROR_CODE) {
			showToastV2({
				title: tInvestor('investment.toast.upload_failed'),
				state: 'error',
			});
			return;
		}

		const message = isStandardBackendError(error)
			? tDefault(`error_codes.${error.error?.code}`)
			: tDefault('common_api_wrapper.local.message');

		showToastV2({
			title: message,
			state: 'error',
		});
	};
};
